var findItemByNodeId = function findItemByNodeId(menu, nodeId) {
    var selectedItem = null;
    var findNodeId = function findNodeId(items) {
        items.forEach(function (item) {
            if (item.nodeId === nodeId) {
                selectedItem = item;
                return item;
            } else if (item.children) {
                findNodeId(item.children);
            }
        });
    };

    findNodeId(menu);

    return selectedItem;
};

export default findItemByNodeId;